<script setup lang="ts">
import { useQRCode } from '@vueuse/integrations/useQRCode'

const model = useTemplateRef('model')
const esProduct = inject('esProduct')

const { threeDModel } = useBynderAssets(esProduct as ComputedRef)

const isReady = ref(false)

const { public: config } = useRuntimeConfig()
const route = useRoute()
const qrcode = useQRCode(config.baseDomain + route.path + '?modal=ar')
const ARand3DDialog = useUiDialog('media-ar-and-3d')

const onError = (event) => {
  console.log(event)
  console.error('Error loading 3D model')
}

const onBeforeRender = () => {
  isReady.value = true
}

watchEffect(() => {
  if (isReady.value) {
    console.log('modelViewer', model.value?.modelViewer?.canActivateAR)
  }
})

onMounted(async () => {
  await nextTick()

  model.value?.modelViewer?.addEventListener('error', onError)
  model.value?.modelViewer?.addEventListener('before-render', onBeforeRender)

  // setTimeout(() => {
  //   console.log('modelViewer', model.value?.modelViewer?.canActivateAR)
  // }, 3000)

  if (route.query.modal === 'ar') {
    ARand3DDialog.open()
  }
})

onUnmounted(() => {
  model.value?.modelViewer?.removeEventListener('error', onError)
  model.value?.modelViewer?.removeEventListener('before-render', onBeforeRender)
})
</script>

<template>
  <LazyUiDialog
    name="media-ar-and-3d"
    class="media-ar-and-3d"
    dialog-type="modal"
  >
    <template #dialogHeader>
      <span class="dialog__title">{{ $t('View in 3D') }}</span>
    </template>

    <div class="media-ar-and-3d__layout">
      <UiModelViewer
        ref="model"
        :src="threeDModel.glb"
        :data-ios-src="threeDModel.usdz"
        :alt="`${esProduct?.name} - 3D Model`"
        class="media-ar-and-3d__model"
        ar
        :height="728"
        :width="480"
        camera-controls
        touch-action="pan-y"
        shadow-intensity="1"
        auto-rotate
      />

      <div class="media-ar-and-3d__content">
        <div class="media-ar-and-3d__title">
          {{ $t('View in 3D') }}
        </div>

        <div class="media-ar-and-3d__product-info">
          <div class="media-ar-and-3d__visual">
            <img
              class="media-ar-and-3d__image"
              :src="useXcdnImage(esProduct.image, 'f=rs:fit:100:100', esProduct.name)"
              loading="lazy"
              :alt="esProduct.name"
              fetchpriority="low"
              height="80"
              width="80"
            >
          </div>

          <div class="media-ar-and-3d__details">
            <div class="media-ar-and-3d__name">
              {{ esProduct?.mainTitle }}
            </div>
            <div class="media-ar-and-3d__description">
              {{ esProduct?.subTitle }}
            </div>
          </div>
        </div>

        <template v-if="isReady && model?.modelViewer?.canActivateAR">
          <button
            class="media-ar-and-3d__button"
            type="button"
            @click="model?.modelViewer?.activateAR()"
          >
            {{ $t('View in AR') }}
          </button>
        </template>
        <template v-else-if="isReady">
          <p class="media-ar-and-3d__instructions">
            {{ $t('Use your mobile or tablet camera to see how this product fits in your room.') }}
          </p>

          <p>
            <img
              :src="qrcode"
              alt="QR Code"
              loading="lazy"
              fetchpriority="low"
              :height="140"
              :width="140"
            >
          </p>
        </template>
      </div>
    </div>
  </LazyUiDialog>
</template>

<style>
@import url("~layers/components/Product/ARand3DDialog.css");
</style>
